(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

var formatMoney = "$ \{\{amount\}\}";

var smplIsMobile = {
    Android: function() {
        return navigator.userAgent.toLowerCase().match(/android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.toLowerCase().match(/blackberry/i);
    },
    iOS: function() {
        return navigator.userAgent.toLowerCase().match(/iphone|ipad|ipod/i);
    },
    Opera: function() {
        return navigator.userAgent.toLowerCase().match(/opera mini/i);
    },
    Windows: function() {
        return navigator.userAgent.toLowerCase().match(/iemobile/i);
    },
    any: function() {
        return (smplIsMobile.Android() || smplIsMobile.BlackBerry() || smplIsMobile.iOS() || smplIsMobile.Opera() || smplIsMobile.Windows());
    }
};



jQuery(function($) {
  	if(!smplIsMobile.any()) {
      $('body').addClass('isNotMobile'); 
    }

  	$(document).on("click", ".quantity .minus", function() {
      	var wrapper = $(this).parent();
    	try {
          wrapper.find('input[type=number]').get(0).stepDown();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())-1);
          wrapper.find('input[type=number]').val((value>=1 ? value : 1));
          wrapper.find('input[type=number]').change();
        }
       var id=$(this).parent().find('input[type=number]').attr('id');
      var qq= $(this).parent().find('input[type=number]').val();
      updateMe(id,qq);
  	});
  	$(document).on("click", ".quantity .plus", function() {
      	var wrapper = $(this).parent();
    	try {
          wrapper.find('input[type=number]').get(0).stepUp();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())+1);
          wrapper.find('input[type=number]').val(value);
          wrapper.find('input[type=number]').change();
        }
      var id=$(this).parent().find('input[type=number]').attr('id');
      var qq= $(this).parent().find('input[type=number]').val();
      updateMe(id,qq);
  	});

  	if($('#side-cart').length > 0) {
    	initSideCart();
    }else{
    	initMiniCart();
    }


  	$('body').delegate('form[action="/cart/add"]', 'submit', function(e){

		var subPDPFormAdd = $(this).hasClass('js-subscription-pdp-add-to-cart')

		// make sure subscription option is selected
		var singleOptionEl = $(this).find('.rc_option__one-time')
		var singleProdOptionActive = singleOptionEl.hasClass('active')
		var subConfirmed = window.subConfirmed


        if(validateAddCart($(this))) {

        	if ( subPDPFormAdd && 
        		!subConfirmed &&
        		!singleProdOptionActive
        	) {
        		// store form for use when confirmed
        		// post goes through from confirming in modal
				window.subPromptForm = $(this)

        		e.preventDefault()
				openSubConfirm()
				return false
        	} 

        	else {
              addToCart($(this));
        	}
        }
        return false;
    });

  	// confirm subscription modal
	$('.js-confirm-terms-sub-pdp').on('click', function() {
		var subPromptForm = window.subPromptForm

		// set for future checks on this page
		window.subConfirmed = true

		// if form is there, add checkbox, close modal, submit stored form
		if (subPromptForm) {
			$(this).find('.js-confirm-text-sub-pdp-checkbox').addClass('is-checked')
			$('.js-close-sub-confirm-modal').trigger('click')

			addToCart(subPromptForm)
		} else {
			console.log('Error submitting saved form after confirming subscription')
		}
	})

  	$(window).scroll(function(){
        if($(this).scrollTop()<=200) {
          $('.scrollup').fadeOut();
        } else {
          $('.scrollup').fadeIn();
        }

      

	  	var controlTest = $('body').hasClass('vwo-control-sticky-header')
	  	// console.log('controlTest', controlTest)	

      	if (controlTest) {
	      	if( $(this).scrollTop() > $('#header .c-headerStickyOffset').height() ) {
	            var headerHeight = $('#header .c-headerSticky').height()

	          	$('#header').addClass('scroll');
	            $('body').addClass('sticky-header')

	            if (!$('body').hasClass('templateIndex') 
	                && !$('body').hasClass('page-artofcharm') 
	                && !$('body').hasClass('page-landing-template')
	                && !$('body').hasClass('page-landing-green-smoothie')
	                && !$('body').hasClass('page-landing-instant-packets-coffee')
		            && !$('body').hasClass('page-landing-tim-ferriss')
		            && !$('body').hasClass('page-100-days-of-real-food-new')
	                && !$('body').hasClass('page-landing-matcha') ){
	                $('.content-wrapper').css('margin-top', 11 );
	            }

	            if ($('body').hasClass('page-landing-affiliate')||
	                	$('body').hasClass('page-artofcharm') ||
	                	$('body').hasClass('page-landing-template') ||
	                	$('body').hasClass('page-landing-green-smoothie') ||
	                	$('body').hasClass('page-landing-instant-packets-coffee') ||
		                $('body').hasClass('page-landing-matcha') ||
		                $('body').hasClass('page-landing-tim-ferriss') ||
		                $('body').hasClass('page-landing-golden-latte') ||
		                $('body').hasClass('page-100-days-of-real-food-new') ||
		                $('body').hasClass('page-landing-cacao-reishi') 

	            	) {
	                $('.content-wrapper').css('padding-top', headerHeight );
	            }


	        } else {

	            var headerHeight = $('#header').height()

	            if (!$('body').hasClass('templateIndex') 
	                && !$('body').hasClass('page-artofcharm') 
	                && !$('body').hasClass('page-landing-template') 
	                && !$('body').hasClass('page-landing-green-smoothie') 
	                && !$('body').hasClass('page-100-days-of-real-food-new') 
	                && !$('body').hasClass('page-landing-instant-packets-coffee') 
	                && !$('body').hasClass('page-landing-tim-ferriss') 
	                && !$('body').hasClass('page-landing-matcha') ){
	                $('.content-wrapper').css('margin-top', 0 );
	            }

	            if ($('body').hasClass('page-landing-affiliate')||
	                	$('body').hasClass('page-artofcharm') ||
	                	$('body').hasClass('page-landing-template') ||
	                	$('body').hasClass('page-landing-green-smoothie') ||
	                	$('body').hasClass('page-100-days-of-real-food-new') ||
	                	$('body').hasClass('page-landing-instant-packets-coffee') ||
		                $('body').hasClass('page-landing-matcha') ||
		                $('body').hasClass('page-landing-tim-ferriss') ||
		                $('body').hasClass('page-landing-golden-latte') ||
		                $('body').hasClass('page-landing-cacao-reishi') 
	            ) {
		            $('.content-wrapper').css('padding-top', 0 );
	            }

	            $('body').removeClass('sticky-header')
	            $('#header').removeClass('scroll');
	        }
	    }
      
    });
  
  	

  	//$("a[rel='fancybox']").fancybox(fancyboxSettings);
  
    
  
  	$('#footer .mailing-list form').submit(function(e){
    	e.preventDefault();
      	e.stopImmediatePropagation();

      	$(this).find('.error').removeClass('error');
      
      	var error = false;
      	$(this).find('.required').each(function(){
          if($(this).val()=="") {
          	error = true;
            $(this).addClass('error');
          }
        });
      	if(!error) {
          if(!validateEmail($(this).find('.email').val())) {
            error = true;
          	$(this).find('.email').addClass('error');
          }
        }
      
      	if(!error) {
          var form = $(this);
          $.ajax({
              url: form.attr('action'),
              data: form.serialize(),
              type: 'POST'
          }).done(function(){
              $('#footer .mailing-list form').fadeOut(function(){
                  $('#footer .mailing-list .success').fadeIn();
              });
          });
        }
    });
});

function openSubConfirm() {

	var modalOverlay = ("<div class='c-overlay js-modalOverlay js-modalClose'></div>");

    var modalElement = $('#product-subscription-confirm-popup-modal')
    modalElement.addClass('is-open')

    $('#PageContainer').append(modalOverlay)

    $('.js-modalOverlay').fadeTo(300, 0.7);

    // Delay modal display none
    setTimeout(function () {
        modalElement.addClass('is-open');
        $('body').addClass('modal-is-open');
    }, 1);	
}

function validateEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}

function validateAddCart(form) {

  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}


function initSideCart() {
	$('.cart-wrap').click(function(e){
      // e.stopPropagation();
      showSideCart(true);
      // return false;
    });

    $('.js-show-side-cart').click(function(e){
      e.stopPropagation();
      e.preventDefault();
      showSideCart(true);
      setTimeout(function() {
          updateFreeShippingCounter()
      }, 200)
      return false;
    });

    $(document).click(function(event){
      
      if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="add-cart-overlay" && $('#side-cart').hasClass('open')) {
      
         hideSideCart();
        
      }
      
    });

    $('body').delegate('#side-cart a.remove-from-cart', 'click', function(){
      var variantId = $(this).attr('href').replace('#', '');
      
      	removeItemToCart(variantId);
      
	    return false;
    });
}

function initMiniCart() {
	$('.header .cart-wrap > a').click(function(e){
      e.preventDefault();
      e.stopPropagation();
      $(this).parent().find('#mini-cart').slideToggle();
    });

    $(document).click(function(event){
      if(!$(event.target).closest('#mini-cart').length && $(event.target).attr('id')!="add-cart-overlay") {
        $('#mini-cart').slideUp();
      }
    });

    $('body').delegate('#mini-cart a.remove-from-cart', 'click', function(){
      var variantId = $(this).attr('href').replace('#', '');
      
	   	removeItemToCart(variantId);
	    return false;
    });
  
  
  
      
    
}



function updateCart(cart){
    	$('#add-cart-overlay').fadeIn();
        //console.log(cart);
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          //async: false,
          data: cart.find('form').serialize(),
          dataType: 'json',
          error: function(error){
            console.log('error');
          },
          success: function(){
            addToCartSuccess();
            $('#add-cart-overlay').fadeOut();
          },
        });
    }



/**
 * Ajaxy add-to-cart
 */
function addToCart(form){
	$('#add-cart-overlay').fadeIn();
  	//$.fancybox.close();


    // console.log(form.serialize())
  
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		//async: false,
		data: form.serialize(),
		dataType: 'json',
		error: addToCartFail,
        success: function(){
          
          addToCartSuccess();
          
        },
		cache: false
	});
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
	updateCartDesc();
}

function addToMiniCartSuccess(jqXHR, textStatus, errorThrown){
	updateMiniCartDesc();
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#add-cart-overlay').fadeOut();

  	$.fancybox('<div class="error-itemincart">'+(response.status==422 ? 'Oops! The last item in stock of this product is already in your cart.' : response.description)+'</div>', {
      padding: 0,
      margin: [40,30,20,10],
      closeEffect: 'fade',
      autoCenter: true,
      helpers: {
        overlay: { speedOut : 500 }
      }
    });
}

function removeItemToCart(variantId){
  	$('#add-cart-overlay').fadeIn();

	//$('#side-cart').remove();
  	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
      	data: {
          id: variantId,
          quantity: 0
        },
		dataType: 'json',
      	error: function(){
      		updateCartDesc();
          	$('#add-cart-overlay').fadeOut();
      	},
      	success: function(){
          	updateCartDesc();
      		$('#add-cart-overlay').fadeOut();
      	},
		cache: false
	});
}

function addPromoToCartByVariant(variant, quantity, onCartPage){

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: quantity,
            id: variant
        },
        dataType: 'json',
        error: addToCartFail,
        success: function(){
        	if (onCartPage) {
        		window.location.href = "https://oyasinstore.myshopify.com/cart/";
        	}

        	else {
	          	
	          	addToCartSuccess();
	          	
	        }
        },
        cache: false
    });
}

function removePromoItemToCart(variantId, onCartPage){

    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: variantId,
          quantity: 0
        },
        dataType: 'json',
        error: function(){
            updateCartDesc();
            $('#add-cart-overlay').fadeOut();
        },
        success: function(){

        	if (onCartPage) {
        		window.location.href = "https://oyasinstore.myshopify.com/cart/";
        	}

        	else {
	            updateCartDesc();
	            $('#add-cart-overlay').fadeOut();
	        }
        },
        cache: false
    });
}

// run promo logic on cart liquid page load
$(document).ready(function(){
	console.log('DOC READY')

    if ($('body').hasClass('templateCart')) {
    	console.log('cart Page')

    	// true for on cart page
    	// cartPromoLogic(true)

    }
})

// if subtotal over certain amount, add free gift item
function cartPromoLogic(onCartPage) {

    var cart
    var giftProductVariantId = 1752865046548 // Canvas Tote Bag
    var promoAmountRequired = 9500 // $95
    var promoAmountReached = false
    var promoInCart = false
    var updatesObject = {}

    function calculateGift(cart, onCartPage) {

        // greater or equal to promo amount
        if (cart.total_price >= promoAmountRequired) {
            promoAmountReached = true
        }

        // check if free gift already in there
        cart.items.forEach(function(item) {
            if (item.id == giftProductVariantId) {
                promoInCart = true
            }
        })            

        if (!promoInCart && promoAmountReached) {
            addPromoToCartByVariant(giftProductVariantId ,1, onCartPage)
        } else if (promoInCart && !promoAmountReached) {
            removePromoItemToCart(giftProductVariantId, onCartPage);
        } 
    }

    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(data){
            cart = data
            calculateGift(cart)
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log(errorThrown)
        },
    });        
}

function updateFreeShippingCounter() {
    console.log('updateFreeShippingcounter()')

    function updateFreeShippingCounterLogic(cart) {
        // console.log('updateFreeShippingCounterLogic')

        var shippingSectionEl = $('.js-cart-shipping-section')
        var shippingAmountAwayText = $('.js-cart-shipping-amount-away-text')
        var shippingProgressPercentageText = $('.js-cart-shipping-progress-percentage-text')
        var progressBarEl = $('.js-cart-progress')

        var freeShippingPoint = 10000;
        var remainingToFreeShipping = freeShippingPoint - cart.total_price;
        var freeShippingReached = (remainingToFreeShipping <= 0 ) ? true : false;
        
        var percentageText;
        var amountAwayText;

        if (freeShippingReached) {
            shippingSectionEl.addClass('is-free-shipping');
            shippingSectionEl.removeClass('is-in-progress');

            //shippingProgressPercentageText.text('100%');
            progressBarEl.css('width', '100%');
            shippingProgressPercentageText.css('left', '100%');            
        } else {
            amountAwayText = (remainingToFreeShipping / 100);
            //percentageText = Math.round(100 - (remainingToFreeShipping / 100));
              percentageText = 100 / (freeShippingPoint / cart.total_price); 
              console.log(percentageText)
            shippingAmountAwayText.text('$' + amountAwayText);
            //shippingProgressPercentageText.text(percentageText + '%')

            progressBarEl.css('width', percentageText + '%');
            shippingProgressPercentageText.css('left', percentageText + '%')

            shippingSectionEl.addClass('is-in-progress')
            shippingSectionEl.removeClass('is-free-shipping')
        }
    }

    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(data){
            cart = data
            updateFreeShippingCounterLogic(cart)
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log(errorThrown)
        },
    });  
}


// Runs on cart updates
function updateCartDesc(runCartPromo){  

	console.log('updateCartDesc')

    // var runCartPromo = (typeof runCartPromo === 'undefined') ? true : runCartPromo;

    // if (runCartPromo) {
        // cartPromoLogic()
    // }
 
  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
             console.log(data);
             console.log('success within updateCartDesc')
          	$('#add-cart-overlay').fadeOut();
          
      		var animate = true;
          	if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
              	animate = false;
            }
          	//$('#shopify-section-cart2-template').remove();
          var success =  $(data).closest("#shopify-section-cart2-template").find('#side-cart .vwo-cart-test'); 
           console.log(success[0]); // div#success
            
        
           $('.new-drawer #shopify-section-cart2-template #side-cart').html(success);
          
          	if(!animate) {
              $('#side-cart').removeClass('ease-animation-med');
            }
          	//$.fancybox.close();
            var itemsCount = 0;
    $('#side-cart .quantity input[type=number]').each(function(){
      itemsCount += parseInt($(this).val());
    });
    $('.cart-wrap #CartCount span').html(itemsCount );
    $('.js-cart-item-count-display').html(itemsCount);
          	showSideCart(animate);
            updateFreeShippingCounter()
      	}
	});
  
     $.getJSON('/cart.js', function (json) {
   var obj = json.items;
  // var obj = JSON.stringify(json);
   //console.log(obj);
   $.each(obj, function(i, item) {
    var recharge=item.properties;
     if(recharge!=null){
      
    $('#side-cart form.js-checkout-form .c-cartDrawer__otherPay').css('display','none');    
     }
});

});
       $.getJSON('/cart.js', function (json) {
   var obj = json.items;
  // var obj = JSON.stringify(json);
   //console.log(obj);
   $.each(obj, function(i, item) {
    var recharge=item.properties;
     if(recharge!=null){
      
    $('#side-cart form .c-cartDrawer__otherPay').css('display','none');    
     }
});

});
}

function updateMiniCartDesc(){  
  	$.ajax({
		type: 'GET',
		url: '/cart?view=mini-cart',
		cache: false,
      	success: function(data){
          	$('#add-cart-overlay').fadeOut();
          
      		var animate = true;
          if($('#mini-cart').is(':visible')) {
              	animate = false;
            }
          	$('#mini-cart .minicart-wrap').remove();
          	$('#mini-cart').append(data);
          	if(!animate) {
              $('#side-cart').removeClass('ease-animation-med');
            }
          	//$.fancybox.close();
          	$('#mini-cart').slideDown();
      	}
	});
}

function showSideCart(animate) {
    console.log('SHOW SIDE CART')
    updateFreeShippingCounter()

    // console.log('run show side cart')
  $('.js-mobile-menu').removeClass('is-open')
  $('.js-mobile-menu-overlay').remove()

  $('body, html').addClass('mm-opened').css({overflow: 'hidden'});
  $('#PageContainer').addClass('mode-overlay');
  if(animate) {
    setTimeout(function(){$('#side-cart').addClass('open')}, 100);
  } else {
  	$('#side-cart').addClass('open');
    setTimeout(function(){$('#side-cart').addClass('ease-animation-med')}, 200);
  }
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#PageContainer').removeClass('mode-overlay');
  $('body, html').removeClass('mm-opened').css({overflow: ''});
}

function getQueryParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function updateMe(variantId,quant){
  	$('#add-cart-overlay').fadeIn();

	//$('#side-cart').remove();
  	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
      	data: {
          id: variantId,
          quantity: quant
        },
		dataType: 'json',
      	error: function(){
      		updateCartDesc();
          	$('#add-cart-overlay').fadeOut();
      	},
      	success: function(){
          	updateCartDesc();
      		$('#add-cart-overlay').fadeOut();
      	},
		cache: false
	});
}